/**
 * @author funfly
 * @mail 389193@qq.com
 * @date 2023-2-20
 * @copyright Gridy.Art
 */
import i18n from '../../lang'
import BLOKY from '../palette/BLOKY.js'
import BEADS from '../palette/BEADS.js'
import DIAMOND from '../palette/DIAMOND.js'
import D3 from '../palette/D3.js'
// import HDD from '../palette/HDD.js'
// import KK from '../palette/KK.js'
// import MM from '../palette/MM.js'
// import MXW from '../palette/MXW.js'
// import PP from '../palette/PP.js'
// import XW from '../palette/XW.js'
const extendPalettes = {
  'BLOKY': BLOKY,
  'D3': D3,
  'DIAMOND': DIAMOND,
  'BEADS': BEADS
  // 'HDD': HDD,
  // 'KK': KK,
  // 'MM': MM,
  // 'MXW': MXW,
  // 'PP': PP,
  // 'XW': XW
}
Object.keys(extendPalettes).map((k) => {
  extendPalettes[k].ids = {}
  extendPalettes[k].colors = {}
  Object.values(extendPalettes[k].data).map((color) => {
    color.id = color.id.toString()
    extendPalettes[k].ids[color.hex] = color.id
    extendPalettes[k].colors[color.id] = color.hex
  })
})
// eslint-disable-next-line
const $t = (key, value) => i18n.t(key, value)
const ALL_COLORS = BLOKY.data
const D3_COLORS = D3.data
// eslint-disable-next-line
const hexToRgb = function(hex) {
  const hexInt = parseInt(hex.replace('#', ''), 16)
  const r = (hexInt >> 16) & 255
  const g = (hexInt >> 8) & 255
  const b = hexInt & 255
  return [r, g, b]
}
// eslint-disable-next-line
const rgbToHex = function(r, g, b) {
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
}
const getDarkenedColor = function(color) {
  const arr = hexToRgb(color)
  const rgb = arr.map((color) => Math.round((color * Math.PI) / 4))
  return rgbToHex(...rgb).toUpperCase()
}
// 风格化颜色映射表：
const colorfyColors = {
  '#FEFBF5': 'A01',
  '#FFE155': 'A21',
  '#FFCC00': 'A22',
  '#DC6AA0': 'A28',
  '#005FAD': 'A41',
  '#212121': 'A06',
  '#DACBBE': 'A80',
  '#CAB5A2': 'A81',
  '#BA9E85': 'A82',
  '#663651': 'A83',
  '#174664': 'A42',
  '#FFAA00': 'A23',
  '#B15218': 'A16',
  '#482413': 'A18'
}
const brickfyGray = ['#FEFBF5', '#E6E6E4', '#ADADB0', '#838588', '#616160', '#212121']
const danceReplace = {
  '#FEFBF5': '#FEFBF5',
  '#E6E6E4': '#FFE155',
  '#ADADB0': '#FFCC00',
  '#838588': '#DC6AA0',
  '#616160': '#005FAD',
  '#212121': '#212121'
}
const classicReplace = {
  '#FEFBF5': '#DACBBE',
  '#E6E6E4': '#CAB5A2',
  '#ADADB0': '#BA9E85',
  '#838588': '#663651',
  '#616160': '#174664',
  '#212121': '#212121'
}
const goldenReplace = {
  '#FEFBF5': '#FFE155',
  '#E6E6E4': '#FFCC00',
  '#ADADB0': '#FFAA00',
  '#838588': '#B15218',
  '#616160': '#482413',
  '#212121': '#212121'
}
// eslint-disable-next-line
// const blokyReplace = {
//   '#E8E8E8': '#AFB5C7',
//   '#E4E8E8': '#AFB5C7',
//   '#9C9C9C': '#AFB5C7',
//   '#6B5A5A': '#595D60',
//   '#6A0E15': '#B30006',
//   '#FF6326': '#FF5500',
//   '#FF7D5D': '#FF8172',
//   '#C58D80': '#FF8172',
//   '#50372F': '#6B3F22',
//   '#735442': '#6B3F22',
//   '#82422A': '#6B3F22',
//   '#99663E': '#B35408',
//   '#A16C42': '#B35408',
//   '#B3694E': '#B35408',
//   '#B89869': '#B35408',
//   '#EED9A4': '#FFDCA4',
//   '#FECCB0': '#FFDCA4',
//   '#FBC685': '#FFDCA4',
//   '#FFAF7D': '#FFDCA4',
//   '#E3A05B': '#B35408',
//   '#CE7942': '#B35408',
//   '#EA8339': '#FF7E14',
//   '#EF9121': '#FF7E14',
//   '#E6881D': '#FF7E14',
//   '#B24817': '#B35408',
//   '#FA5947': '#FF5500',
//   '#FFA531': '#FF7E14',
//   '#FFBC36': '#FFC700',
//   '#FFD788': '#FFC700',
//   '#DD982E': '#FF7E14',
//   '#D89905': '#FF7E14',
//   '#FFE001': '#FFC700',
//   '#FEE89F': '#FFDCA4',
//   '#FFF08C': '#FFDCA4',
//   '#FFFC00': '#FFC700',
//   '#EDDC44': '#FFC700',
//   '#DBF355': '#DFE000',
//   '#ECEEBD': '#DFE000',
//   '#E7F2A7': '#DFE000',
//   '#ADD237': '#C4E000',
//   '#76753F': '#ABA953',
//   '#2E5543': '#00923D',
//   '#91DF8C': '#00923D',
//   '#D7EED1': '#C4E000',
//   '#A2BFA3': '#00923D',
//   '#00A29F': '#00C5BC',
//   '#CFEFEA': '#BCE5DC',
//   '#243757': '#0057A6',
//   '#5DBFE4': '#506CEF',
//   '#7DC1D8': '#6ACEE0',
//   '#8AD4E1': '#6ACEE0',
//   '#82ADD8': '#9391E4',
//   '#BCD1ED': '#9391E4',
//   '#C8D9E1': '#9391E4',
//   '#8899AB': '#AFB5C7',
//   '#3448A4': '#506CEF',
//   '#CDCCEE': '#9391E4',
//   '#C9CAE2': '#9391E4',
//   '#5F2683': '#7A238D',
//   '#AF3195': '#EF5BB3',
//   '#D3BDE3': '#C689D9',
//   '#E0AAD9': '#C689D9',
//   '#B57DA5': '#C689D9',
//   '#B72276': '#EF5BB3',
//   '#F7BCDA': '#F785B1',
//   '#F2D3D1': '#F5CDD6'
// }
const getLimitColorsConf = () => {
  // 修正颜色限制数量
  const limitColorsConf = {
    // 修正颗粒数
    fixNums: 300,
    // 双倍修正：允许额外多出来的误差颗粒数
    allowErrNums: 30,
    // 单倍修正颗粒颜色 在颜色列表中的多给300颗
    fixColors: {
      'dance': ['#FEFBF5', '#FFCC00', '#212121'],
      'classic': ['#DACBBE', '#BA9E85', '#212121'],
      'golden': ['#FFE155', '#FFAA00', '#212121']
    },
    // 双倍修正颗粒颜色 在颜色列表中的再多给300颗
    doubleFixColors: {}
  }
  if (window.location.hash && window.location.hash.toLowerCase().indexOf('doublefix=1') >= 0) {
    // 参考控制是否开启双倍补偿
    limitColorsConf.doubleFixColors = {
      'dance': ['#212121'],
      'classic': ['#212121'],
      'golden': ['#212121']
    }
  }
  Object.keys(limitColorsConf.fixColors).map((k) => {
    Object.values(limitColorsConf.fixColors[k]).map((color) => {
      limitColorsConf.fixColors[k].push(getDarkenedColor(color))
    })
  })
  Object.keys(limitColorsConf.doubleFixColors).map((k) => {
    Object.values(limitColorsConf.doubleFixColors[k]).map((color) => {
      limitColorsConf.doubleFixColors[k].push(getDarkenedColor(color))
    })
  })
  return limitColorsConf
}

const d3 = {}
const d3Arr = []
Object.values(D3_COLORS).map((color) => {
  color.hex = color.hex.toUpperCase()
  d3Arr.push(color.hex)
  d3[color.id] = color.hex
})
const brickfy = {}
const brickfyArr = []
const darkenedBrickfy = {}
Object.values(ALL_COLORS).map((color) => {
  color.hex = color.hex.toUpperCase()
  brickfyArr.push(color.hex)
  brickfy[color.id] = color.hex
  darkenedBrickfy[color.id] = getDarkenedColor(color.hex)
})
const getDarkPalette = (palObj) => {
  const pObj = {}
  Object.keys(palObj).map((k) => {
    pObj[getDarkenedColor(k)] = palObj[k]
  })
  return pObj
}
const main = {
  names: () => {
    const arr = {
      // base: $t('paletteName.base')
      // brickfy: $t('paletteName.brickfy')
      // skin: $t('paletteName.skin'),
      // dance: $t('colorfy.dance'),
      // classic: $t('colorfy.classic'),
      // golden: $t('colorfy.golden'),
      // colors: $t('colorfy.colors')
      // gray: $t('paletteName.gray')
      // metals: $t('paletteName.metals')
    }
    Object.keys(extendPalettes).map((k) => {
      if (!extendPalettes[k].hide) arr[k] = $t('extendPalettes.' + k)
    })
    return arr
  },
  colorfy: () => {
    return {
      dance: { name: $t('colorfy.dance'), palette: danceReplace, darkPalette: getDarkPalette(danceReplace) },
      classic: { name: $t('colorfy.classic'), palette: classicReplace, darkPalette: getDarkPalette(classicReplace) },
      golden: { name: $t('colorfy.golden'), palette: goldenReplace, darkPalette: getDarkPalette(goldenReplace) }
    }
  },
  frames: frames,
  base: ['#000000', '#ffffff', '#eeece1', '#e2534d', '#f9974c', '#ffc12a', '#9aba60', '#47acc5', '#1e497b', '#956FE7', '#808080', '#f2f2f2', '#ddd8c3', '#f2dbdb', '#fee9da', '#fff2cc', '#eaf1de', '#d9eef3', '#c6d9f0', '#f0edf6', '#696969', '#dbdbdb', '#b6b29f', '#d5b6b6', '#e9c9b1', '#e5d4a3', '#cad4ba', '#b3d0d7', '#a1b4cc', '#d0c3dc', '#525252', '#c4c4c4', '#8f8c7b', '#b89291', '#d5a988', '#cbb77a', '#abb796', '#8eb2bb', '#7c90a8', '#b099c3', '#3b3b3b', '#adadad', '#696657', '#9c6e6c', '#c18960', '#b29a51', '#8b9a73', '#68949f', '#576c84', '#906faa', '#242424', '#969696', '#424033', '#7f4a47', '#ad6937', '#987d28', '#6c7d4f', '#437683', '#324860', '#704591'],
  d3: d3,
  d3Arr: d3Arr,
  brickfy: brickfy,
  brickfyArr: brickfyArr,
  darkenedBrickfy: darkenedBrickfy,
  brickfyGray: brickfyGray,
  dance: Object.values(danceReplace),
  classic: Object.values(classicReplace),
  golden: Object.values(goldenReplace),
  skin: ['#ffe0bd', '#ffdbac', '#ffcd94', '#eac086', '#e0ac69', '#f1c27d', '#ffad60', '#c68642', '#8d5524', '#765339', '#613D24', '#4C2D17', '#391E0B', '#2D1304', '#180A01', '#090300'],
  gray: ['#F0F0F0', '#E0E0E0', '#D0D0D0', '#C0C0C0', '#B0B0B0', '#A0A0A0', '#909090', '#808080', '#707070', '#606060', '#505050', '#404040', '#303030', '#202020', '#101010', '#000000'],
  metals: ['#000000', '#996614', '#946D0A', '#A5790B', '#B8870C', '#BF9325', '#C69E3B', '#784F11', '#848A99', '#848588', '#939598', '#A4A6AA', '#ADAFB2', '#B5B7B9', '#595D66', '#6B3805', '#643A00', '#704100', '#7D4900', '#8A5B1A', '#956B31', '#4D2804', '#4D4D4D', '#6A6A68', '#767674', '#848482', '#90908E', '#9B9B99', '#363636', '#B36452', '#924F39', '#A3583F', '#B56246', '#BD7259', '#C4806A'],
  // colors: ['#D5B69F', '#E3D3C5', '#FFFBF5', '#653350', '#144463', '#151515'],
  extendPalettes: extendPalettes,
  // blokyReplace: blokyReplace,
  colorfyColors: colorfyColors,
  getLimitColorsConf: getLimitColorsConf
}
Object.keys(extendPalettes).map((k) => {
  const colorsData = extendPalettes[k].data
  const colors = []
  for (const color of colorsData) {
    colors.push(color.hex)
  }
  main[k] = colors
})
export default main
